// Token persistence.
//
// SECURITY — the tradeoff, restated rather than inherited silently:
//   POST /api/auth/verify returns the JWT in the JSON body; there is no Set-Cookie
//   path, and a client cannot create an httpOnly cookie. So this is sessionStorage:
//   XSS-readable, CSRF-immune, and cleared when the tab closes. localStorage is
//   avoided on purpose — a per-tab lifetime is closer to what people expect from a
//   console. When the API ships an httpOnly cookie, this module becomes a no-op and
//   the Authorization header injection in client.js goes away.
//
// There is no tenant and no user object here. This API authenticates an EMAIL against
// an allowlist — that is the whole identity model, and storing a richer shape than the
// server actually returns is how you end up with a `tenant` that is permanently null
// and a reader who assumes it means something.

const TOKEN_KEY = 'alfred.freight.token';
const EMAIL_KEY = 'alfred.freight.email';

// Every accessor is wrapped: Safari private mode throws on storage access, and an auth
// layer that explodes on read is worse than one that forgets you.
const safe = (fn, fallback = null) => { try { return fn(); } catch { return fallback; } };

export const getStoredToken = () => safe(() => sessionStorage.getItem(TOKEN_KEY));
export const setStoredToken = (t) => safe(() => { sessionStorage.setItem(TOKEN_KEY, t); return true; }, false);
export const getStoredEmail = () => safe(() => sessionStorage.getItem(EMAIL_KEY));
export const setStoredEmail = (e) => safe(() => { sessionStorage.setItem(EMAIL_KEY, e); return true; }, false);

export function clearStoredAuth() {
  safe(() => { [TOKEN_KEY, EMAIL_KEY].forEach((k) => sessionStorage.removeItem(k)); return true; }, false);
}
